import React from 'react';
import { Send, RefreshCw } from 'lucide-react';

const AdminSentTab = ({
  sentEmails,
  sentLoading,
  selectedSent,
  setSelectedSent,
  fetchSentEmails,
}) => {
  return (
    <div className="grid lg:grid-cols-3 gap-6">
      {/* Sent Emails List */}
      <div className="lg:col-span-1 bg-white rounded-xl shadow-lg overflow-hidden">
        <div className="p-4 bg-gray-50 border-b border-gray-200 flex justify-between items-center">
          <h2 className="font-bold text-gray-900">Gesendet ({sentEmails.length})</h2>
          <button
            onClick={fetchSentEmails}
            data-testid="refresh-sent-btn"
            className="p-2 hover:bg-gray-200 rounded-lg transition-colors"
          >
            <RefreshCw className={`w-4 h-4 ${sentLoading ? 'animate-spin' : ''}`} />
          </button>
        </div>
        <div className="overflow-y-auto max-h-[calc(100vh-350px)]">
          {sentLoading ? (
            <div className="p-8 text-center">
              <RefreshCw className="w-8 h-8 text-blue-600 animate-spin mx-auto mb-3" />
              <p className="text-gray-500 text-sm">Lade E-Mails...</p>
            </div>
          ) : sentEmails.length === 0 ? (
            <div className="p-8 text-center text-gray-500">
              <Send className="w-12 h-12 mx-auto mb-4 text-gray-300" />
              <p>Noch keine E-Mails gesendet</p>
            </div>
          ) : (
            sentEmails.map((email) => (
              <button
                key={email.sent_at || email.to}
                onClick={() => setSelectedSent(email)}
                data-testid={`sent-email-${email.sent_at}`}
                className={`w-full p-4 border-b border-gray-200 hover:bg-blue-50 transition-colors text-left ${
                  selectedSent === email ? 'bg-blue-50' : ''
                }`}
              >
                <div className="flex items-start justify-between mb-1">
                  <span className="font-semibold text-gray-900 truncate flex-1 text-sm">An: {email.to}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full flex-shrink-0 ml-2 ${
                    email.status === 'sent' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                  }`}>
                    {email.status === 'sent' ? 'Gesendet' : 'Fehlgeschlagen'}
                  </span>
                </div>
                <p className="text-sm font-medium text-gray-700 truncate">{email.subject}</p>
                <p className="text-xs text-gray-400 mt-1">
                  {email.sent_at ? new Date(email.sent_at).toLocaleString('de-DE') : ''}
                </p>
              </button>
            ))
          )}
        </div>
      </div>

      {/* Sent Email Detail */}
      <div className="lg:col-span-2 bg-white rounded-xl shadow-lg p-6">
        {selectedSent ? (
          <div>
            <div className="flex justify-between items-start mb-6">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">{selectedSent.subject}</h2>
                <div className="flex items-center gap-4 text-sm text-gray-600">
                  <span>An: <strong>{selectedSent.to}</strong></span>
                  <span>{selectedSent.sent_at ? new Date(selectedSent.sent_at).toLocaleString('de-DE') : ''}</span>
                  <span className={`px-2 py-0.5 rounded-full text-xs ${
                    selectedSent.status === 'sent' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                  }`}>
                    {selectedSent.status === 'sent' ? 'Gesendet' : 'Fehlgeschlagen'}
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg mb-6">
              <p className="whitespace-pre-wrap text-gray-700">{selectedSent.message}</p>
            </div>
            <button
              onClick={() => setSelectedSent(null)}
              className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg font-semibold hover:bg-gray-300 transition-colors"
            >
              Schliessen
            </button>
          </div>
        ) : (
          <div className="text-center py-20 text-gray-500">
            <Send className="w-16 h-16 mx-auto mb-4 text-gray-300" />
            <p>Waehlen Sie eine gesendete E-Mail aus, um die Details zu sehen</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminSentTab;
